var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "", "align-end": "" } },
    [
      _c("list-edition-toolbar", {
        attrs: { buttons: _vm.toolbarButtons },
        on: {
          add: function($event) {
            return _vm.startEditingItem(null, "create")
          }
        }
      }),
      _vm._v(" "),
      _vm.itemEditionDialog
        ? _c(
            "v-dialog",
            {
              attrs: {
                value: _vm.itemEditionDialog,
                persistent: "",
                "max-width": "350"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { color: "#f0f0ef", "min-height": "160" } },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "text-left pt-1" },
                    [
                      _c(
                        "label",
                        { staticClass: "mixed-input-container-size" },
                        [_vm._v(_vm._s(_vm.$tc("Type", 1)) + " *")]
                      ),
                      _vm._v(" "),
                      _c("treeselect", {
                        staticClass: "mt-1 mixed-input-container-size",
                        attrs: {
                          options: _vm.stepOptions,
                          disableFuzzyMatching: ""
                        },
                        model: {
                          value: _vm.editedItem.type,
                          callback: function($$v) {
                            _vm.$set(_vm.editedItem, "type", $$v)
                          },
                          expression: "editedItem.type"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "mixed-input-container-size" }, [
                        _c("label", [_vm._v(_vm._s(_vm.$tc("Label")) + " *")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.editedItem.label,
                              expression: "editedItem.label"
                            }
                          ],
                          staticClass: "mixed-task-input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.editedItem.label },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.editedItem,
                                "label",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mixed-input-container-size" }, [
                        _c("label", [_vm._v(_vm._s(_vm.$tc("Index")) + " *")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.editedItem.index,
                              expression: "editedItem.index"
                            }
                          ],
                          staticClass: "mixed-task-input",
                          attrs: { type: "number" },
                          domProps: { value: _vm.editedItem.index },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.editedItem,
                                "index",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("v-checkbox", {
                        staticClass: "mt-1",
                        attrs: { label: _vm.$tc("Required"), color: "accent" },
                        model: {
                          value: _vm.editedItem.required,
                          callback: function($$v) {
                            _vm.$set(_vm.editedItem, "required", $$v)
                          },
                          expression: "editedItem.required"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("management-button", {
                        attrs: { type: "cancel", label: _vm.$t("Cancel") },
                        on: { buttonClick: _vm.close }
                      }),
                      _vm._v(" "),
                      _c("management-button", {
                        attrs: {
                          type: "execute",
                          label:
                            _vm.itemIndex !== -1
                              ? _vm.$t("ApplyChanges")
                              : _vm.$t("Add"),
                          disabled: _vm.isBtnDisabled
                        },
                        on: { buttonClick: _vm.applyChanges }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("mixed-table", {
        attrs: {
          list: _vm.editedText,
          "edition-disabled": _vm.editionDisabled,
          allRows: _vm.rowsPerPage
        },
        on: {
          editItem: function($event) {
            return _vm.startEditingItem($event, "edit")
          },
          removeItem: _vm.tryRemoveItem
        }
      }),
      _vm._v(" "),
      _vm.photoList.length > 0
        ? _c("photos", {
            staticClass: "photos",
            attrs: {
              tasks: _vm.photoList,
              taskDecisionButtons: false,
              taskContents: _vm.taskContents,
              isMixedTask: true
            },
            on: {
              updateTaskContents: function($event) {
                return _vm.$emit("updateTaskContents", $event)
              },
              approveTask: function($event) {
                return _vm.$emit("approveTask")
              },
              rejectTask: function($event) {
                return _vm.$emit("rejectTask", $event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.itemDeleteDialog,
          title: _vm.$t("DeleteItem"),
          content:
            _vm.$t("DeleteConfirmation") + " " + _vm.itemToEdit.label + "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: function($event) {
            _vm.itemDeleteDialog = false
          },
          secondaryAction: _vm.removeItem
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51da3a21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51da3a21","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Mixed/Mixed.vue
// module id = null
// module chunks = 